const remote_prod = "https://magico-api.waiv.it/";
const remote_test = "https://magico-api-test.waiv.it/";
const local = "http://localhost:8080/";

export const ROOT_URL = remote_prod;
